import React, { useEffect } from "react";
import { goBack, push } from "connected-react-router";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import TransactionStatus from "pages/transactions/_components/TransactionStatus";
import I18n from "pages/_components/I18n";
import Loader from "pages/_components/Loader";
import { useParams } from "react-router-dom";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import moment from "moment";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import { multipleEcheqsTicketData } from "util/echecks";
import Notification from "pages/_components/Notification";

const titles = {
    endorse: "echecks.endorse",
    "emit-cesion": "echeq.emit.cesion.echeq",
};

const EcheckMultipleTransactionPage = () => {
    const dispatch = useDispatch();
    const { status } = useParams();
    const { echeqsEndorseData: endorseData, cesionEcheqData: cesionData, echeqsToDoActions: echeqAction } = useSelector(
        (state) => state.echecks,
    );

    useEffect(() => {
        if (isEmpty(echeqAction)) {
            dispatch(goBack());
        }
    }, [dispatch]);

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    // eslint-disable-next-line consistent-return
    const calculateAmount = () => {
        // const { echeqsToEmit } = this.props;
        if (echeqAction.action.toLowerCase() !== "emit-echeq") {
            return echeqAction.echeqList.reduce((a, b) => a + b.monto, 0);
        }

        // return echeqsToEmit.reduce((a, b) => a + b.amount, 0);
    };

    const bodyTicketItems = multipleEcheqsTicketData(
        echeqAction?.action.toLowerCase() === "emit-cesion" ? "cesion" : echeqAction?.action?.toLowerCase(),
    );

    return (
        <>
            <Notification scopeToShow="multipleSignaturesProcessing" />
            <ResponsiveHeader metaTitle={titles[echeqAction?.action.toLowerCase()]} backLinkTo="/echecks" />
            <MainContainer showLoader={false}>
                <div className="container transaction-ticket">
                    <Row>
                        <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                            <div className="media-object  column">
                                <div className="text-center">
                                    <I18n id={titles[echeqAction?.action.toLowerCase()]} component="h1" />
                                    <I18n id={`ticket.status.${status}`} component="h3" />
                                </div>
                                <figure>
                                    <TransactionStatus iconFidelity="ticket" idTransactionStatus={status} />
                                </figure>
                            </div>
                        </Col>
                    </Row>

                    <GridTable>
                        <GridTable.Container columns={3} rows={2}>
                            <GridTable.Data columnStart={1} rowStart={1}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.createdRange.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText
                                            textType="DATE"
                                            className="data-label"
                                            text={moment()}
                                            dateFormat="DD/MM/YYYY HH:mm:ss"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>

                            {echeqAction?.action.toLowerCase() !== "emit-cesion" &&
                                echeqAction?.action.toLowerCase() !== "emit-echeq" && (
                                    <>
                                        <GridTable.Data columnStart={2} rowStart={1}>
                                            <GridTable.Container columns={1} rows={2} className="mb-4">
                                                <GridTable.Data rowStart={1}>
                                                    <CustomText textType="I18N" text="echecks.beneficiary" />
                                                </GridTable.Data>
                                                <GridTable.Data rowStart={2}>
                                                    <CustomText
                                                        className="data-label"
                                                        text={endorseData?.beneficiary?.reference}
                                                    />
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable.Data>
                                        <GridTable.Data columnStart={3} rowStart={1}>
                                            <GridTable.Container columns={1} rows={2} className="mb-4">
                                                <GridTable.Data rowStart={1}>
                                                    <CustomText textType="I18N" text="echecks.document" />
                                                </GridTable.Data>
                                                <GridTable.Data rowStart={2}>
                                                    <CustomText
                                                        className="data-label"
                                                        text={endorseData?.beneficiary?.document}
                                                    />
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable.Data>

                                        {bodyTicketItems.map((item, index) => (
                                            <GridTable.Data columnStart={index + 1} rowStart={2}>
                                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                                    <GridTable.Data rowStart={1}>
                                                        <CustomText textType="I18N" text={item[Object.keys(item)[0]]} />
                                                    </GridTable.Data>
                                                    <GridTable.Data rowStart={2}>
                                                        {Object.keys(item)[0] === "type" && (
                                                            <CustomText
                                                                textType="I18N"
                                                                className="data-label"
                                                                text={`echecks.endorse.types.${
                                                                    endorseData.endorseData[Object.keys(item)[0]]
                                                                }`}
                                                            />
                                                        )}
                                                        {Object.keys(item)[0] !== "type" && (
                                                            <CustomText
                                                                className="data-label"
                                                                text={endorseData.endorseData[Object.keys(item)[0]]}
                                                            />
                                                        )}
                                                    </GridTable.Data>
                                                </GridTable.Container>
                                            </GridTable.Data>
                                        ))}
                                    </>
                                )}

                            {echeqAction.action.toLowerCase() === "emit-cesion" && (
                                <>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <GridTable.Container columns={1} rows={2} className="mb-4">
                                            <GridTable.Data rowStart={1}>
                                                <CustomText textType="I18N" text="echecks.beneficiary" />
                                            </GridTable.Data>
                                            <GridTable.Data rowStart={2}>
                                                <CustomText
                                                    className="data-label"
                                                    text={cesionData.beneficiary.reference}
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={3} rowStart={1}>
                                        <GridTable.Container columns={1} rows={2} className="mb-4">
                                            <GridTable.Data rowStart={1}>
                                                <CustomText textType="I18N" text="echecks.document" />
                                            </GridTable.Data>
                                            <GridTable.Data rowStart={2}>
                                                <CustomText
                                                    className="data-label"
                                                    text={cesionData.beneficiary.document.toUpperCase()}
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable.Data>

                                    {bodyTicketItems.map((item, index) => (
                                        <GridTable.Data columnStart={index + 1} rowStart={2}>
                                            <GridTable.Container columns={1} rows={2} className="mb-4">
                                                <GridTable.Data rowStart={1}>
                                                    <CustomText textType="I18N" text={item[Object.keys(item)[0]]} />
                                                </GridTable.Data>
                                                <GridTable.Data rowStart={2}>
                                                    <CustomText
                                                        className="data-label"
                                                        text={cesionData.cesionData[Object.keys(item)[0]]}
                                                    />
                                                </GridTable.Data>
                                            </GridTable.Container>
                                        </GridTable.Data>
                                    ))}
                                </>
                            )}

                            <GridTable.Data columnStart={1} rowStart={3}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.amount" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <FormattedAmount
                                            className="data-label"
                                            currency="ARS"
                                            quantity={calculateAmount().toString()}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} rowStart={3}>
                                <GridTable.Container columns={1} rows={2} className="mb-4">
                                    <GridTable.Data rowStart={1}>
                                        <CustomText textType="I18N" text="echecks.emit.quantity.label" />
                                    </GridTable.Data>
                                    <GridTable.Data rowStart={2}>
                                        <CustomText text={echeqAction?.echeqList?.length} />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable>
                    <Row className="form-actions no-print">
                        <Col xs={12} md={4} mdOffset={4}>
                            <Button
                                onClick={() => dispatch(push("/desktop"))}
                                label="forms.transaction.ticket.actions.backToHome"
                                className="btn btn-primary"
                            />
                        </Col>
                    </Row>
                </div>
            </MainContainer>
        </>
    );
};

export default EcheckMultipleTransactionPage;
